import { isAxiosError } from "axios"

// rr-api answers a viewer's write with 403 { error: "view_only" }
// (api/utils/view-only.js). The UI hides write controls for viewers, so this
// only happens when a control slipped through or the role changed while the
// page was open; the customer provider's interceptor then refreshes the role
// and raises VIEW_ONLY_EVENT for <ViewOnlyToast />.
export const VIEW_ONLY_EVENT = "rr:view-only"

export const isViewOnlyRefusal = (error: unknown): boolean =>
    isAxiosError(error) && error.response?.status === 403 && error.response.data?.error === "view_only"
